import { Controller } from "@hotwired/stimulus"

const GA_ID_ANALYTICS = "G-6GEBK275P9"
const GA_ID_ADS = "AW-16558144933"
const CONSENT_SCRIPT_URL = "https://www.freeprivacypolicy.com/public/cookie-consent/4.2.0/cookie-consent.js"

export default class extends Controller {
  connect() {
    this._loadScript()
  }

  _loadScript() {
    const script = document.createElement("script")
    script.src = CONSENT_SCRIPT_URL
    script.charset = "UTF-8"
    script.defer = true
    script.onload = () => this._initBanner()
    document.head.appendChild(script)
  }

  _initBanner() {
    if (typeof cookieconsent === "undefined") return

    cookieconsent.run({
      notice_banner_type: "headline",
      consent_type: "express",
      palette: "dark",
      language: "pl",
      page_load_consent_levels: ["strictly-necessary"],
      notice_banner_reject_button_hide: false,
      preferences_center_close_button_hide: false,
      page_refresh_confirmation_buttons: false,
      website_name: "UprawnieniaKierowcy.pl",
      website_privacy_policy_url: "https://www.uprawnieniakierowcy.pl/page/privacy-policy",
      callbacks_force: true,
      callbacks: {
        scripts_specific_loaded: (level) => {
          if (level === "targeting" || level === "tracking") {
            this._grantGAConsent()
          }
        },
      },
    })
  }

  _grantGAConsent() {
    if (typeof gtag === "undefined") return

    gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    })

    gtag("config", GA_ID_ANALYTICS)
    gtag("config", GA_ID_ADS)
  }
}
